const MoneyFormat = (val) => {
  if (!val) {
    val = 0
  }
  const nf = new Intl.NumberFormat()
  return nf.format(val)
}

export default MoneyFormat
